import React from "react";
import { Mesh, Group, BackSide } from "three";
import { range } from "lodash";

interface GridCoord {
  x: number;
  y: number;
  dist: number;
}
interface AudioVisualiserUIProps {
  circleRadius: number;
  progressIndicatorRadius: number;
  progressWaveformSteps: number;
  progressStepAngle: number;
  gridCoords: GridCoord[];
  progressGroupRef: React.RefObject<Group | undefined>;
  meshRefs: React.RefObject<Mesh | undefined>[];
  progressMeshRefs: React.RefObject<Mesh>[];
}
export const AudioVisualiserUI: React.FC<AudioVisualiserUIProps> = React.memo(
  ({
    circleRadius,
    progressIndicatorRadius,
    progressWaveformSteps,
    progressStepAngle,
    gridCoords,
    progressGroupRef,
    meshRefs,
    progressMeshRefs
  }) => {
    return (
      <>
        <group>
          {gridCoords.map(({ x, y, dist }, i) => (
            <mesh key={`${x},${y}`} position={[x, y, 0]} ref={meshRefs[i]}>
              <sphereBufferGeometry attach="geometry" args={[0.025, 20, 20]} />
              <meshBasicMaterial
                attach="material"
                color="#bbb"
                transparent
                opacity={1 - dist / circleRadius}
              />
            </mesh>
          ))}
        </group>
        <group ref={progressGroupRef} position={[0, 0, -0.01]}>
          {range(progressWaveformSteps).map(idx => (
            <mesh
              key={idx}
              ref={progressMeshRefs[idx]}
              rotation={[0, Math.PI, 0]}
            >
              <circleBufferGeometry
                attach="geometry"
                args={[
                  progressIndicatorRadius,
                  2,
                  (Math.PI * 3) / 2 + idx * progressStepAngle,
                  progressStepAngle
                ]}
              />
              <meshBasicMaterial attach="material" side={BackSide} />
            </mesh>
          ))}
        </group>
      </>
    );
  }
);
